import Image from 'next/image'
import { Fragment } from 'react'

import { Breadcrumbs } from '@components/Breadcrumbs'
import { useIsLaptopL, useIsMobileXL } from '@hooks/use-media-query'
import { Column } from '@ui/sections/Column'

import {
  Title,
  Description,
  ContainerImage,
  Wrapper,
  ContentWrapper,
} from './styles'

export function HeaderSection({
  title,
  subtitle,
  imagePath,
  imageWidth = '360',
  imageHeight = '410',
  imageAlt = 'header avatar',
  imageTitle = 'header avatar',
  imageRight,
  imageBottom = '0',
  textColor = 'black',
  indexMarginTop = '0px',
  repeatImageRight = 0,
  background = 'none',
  mobileReverse = false,
}) {
  const isLaptopL = useIsLaptopL()
  const isTablet = useIsMobileXL()

  const Content = mobileReverse ? ContentWrapper : Fragment

  return (
    <Wrapper
      repeatImageRight={repeatImageRight}
      background={background}
      textColor={textColor}
    >
      <Breadcrumbs textColor={textColor} marginTop={indexMarginTop} />
      <Column className="header-column" width={isLaptopL ? '1100' : '998'}>
        <Content>
          {!isTablet && (
            <Title as="h1" className="header-title">
              {title}
            </Title>
          )}
          {imagePath && (
            <ContainerImage
              imageBottom={imageBottom}
              imageRight={imageRight}
              width={imageWidth}
              height={imageHeight}
              className="header-image"
            >
              <Image
                priority
                width={imageWidth}
                height={imageHeight}
                src={imagePath}
                alt={imageAlt}
                title={imageTitle}
              />
            </ContainerImage>
          )}
          {isTablet && (
            <Title as="h1" className="header-title">
              {title}
            </Title>
          )}
        </Content>

        <Description className="header-description">{subtitle}</Description>
      </Column>
    </Wrapper>
  )
}
